import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=5dd0125e&scoped=true&"
import script from "./SelectedFilters.vue?vue&type=script&lang=js&"
export * from "./SelectedFilters.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFilters.vue?vue&type=style&index=0&id=5dd0125e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0125e",
  null
  
)

export default component.exports